import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import {EmptyAddCard} from '../card/empty-add-card';

import styles from './add-new-card.module.css';

type Props = {
    onClick: () => void;
    text: string;
    isSelectable?: boolean;
    isLoading?: boolean | null | undefined;
    isSelected: boolean;
    height?: number;
};

export function AddNewCard(props: Props) {
    const onClick = props.isLoading ? () => {} : props.onClick;

    return props.isSelectable ? (
        <ButtonCard
            // @ts-expect-error
            style={{height: props.height}}
            fitHeight={true}
            onClick={props.onClick}
            isSelected={props.isSelected}
        >
            <div className={styles['add-card-icon']}>+</div>
            <div className={styles['add-card-label']}>{props.text}</div>
        </ButtonCard>
    ) : (
        <EmptyAddCard
            text={props.text}
            onClick={onClick}
            background='off-white'
            size='small'
            height={props.height}
        />
    );
}
